

















































import Vue from 'vue';
import EnquiryRequestViewModel from '@/src/services/viewModel/resource/EnquiryRequestViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    isSaving: false,
    errorResponse: undefined as string | undefined,
    wasEnquirySend: false,
    enquiry: new EnquiryRequestViewModel(),
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
  },
  mounted() {
  },
  methods: {
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/member-data/member-data-change');
    },
    async sendYourEnquiry() {
      if (!this.enquiry.validate()) {
        return;
      }
      this.isSaving = true;
      this.wasEnquirySend = false;
      this.errorResponse = '';
      try {
        await this.$service.api.memberships.sendMyEnquiry(this.enquiry);
        this.wasEnquirySend = true;
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isSaving = false;
    },
  },
});
